import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";
dayjs.extend(customParseFormat);
var inputFormat = "YYYY-MM-DD";
var outputFormat = "MM/DD/YYYY";
export default function getMiddleOfBirthdayRange(range, birthdayFallback) {
    if (!range) {
        return birthdayFallback
            ? dayjs(birthdayFallback, [inputFormat]).format(outputFormat)
            : "";
    }
    var start = range.start, end = range.end;
    if (start === end) {
        return dayjs(start, [inputFormat]).format(outputFormat);
    }
    var midpoint = dayjs((dayjs(start, [inputFormat]).valueOf() +
        dayjs(end, [inputFormat]).valueOf()) /
        2);
    return midpoint.format(outputFormat);
}
